// extracted by mini-css-extract-plugin
export var cardLayout = "_6a-1";
export var paginationContainer = "_6a-0";